module.exports = __webpack_public_path__ + "img/content-section.70e10c20.jpg";